import { TextField } from '@mui/material';
import * as React from 'react';

const InputField: React.FC<{
  name: string;
  type?: any;
  placeholder: string;
  value?: any;
  onChange?: any;
  focusOnLoad?: boolean;
  startAdornment?: React.ReactNode;
  textarea?: boolean;
  className?: string;
}> = ({
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  focusOnLoad,
  startAdornment,
  textarea,
  className,
}) => {
  return (
    <TextField
      // autoFocus
      multiline={textarea}
      type={type}
      variant='outlined'
      name={name}
      // ref={focusOnLoad ? (input) => input && input.focus() : null}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      sx={{
        width: '100%',
        backgroundColor: 'white',
      }}
      InputProps={{
        startAdornment,
        sx: {
          borderRadius: 1,
          height: 56,
        },
      }}
    />
  );
};

export default InputField;
